import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let lastSection = null;

export const trackPageView = (section = "") => {
  if (section && section === lastSection) return;
  lastSection = section || lastSection;
  axios
    .post(`${API}/analytics/pageview`, {
      path: window.location.pathname + window.location.search,
      section,
      referrer: document.referrer || "",
    })
    .catch(() => {});
};

export const useTrackPageView = (section) => {
  useEffect(() => {
    trackPageView(section);
  }, [section]);
};
